const PROXY = "http://dickensinemiliaromagna.it/back";
export default PROXY;
